import { Component, AfterViewInit, OnInit, Input} from '@angular/core';
import { ObjectProperties, Column } from '../../../../common/components/data-table/models/column.interface';
import { ValueFormatter } from '../../../../common/components/data-table/formatters/data-table.formatters';
/*import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';*/
import { GridOptions, ColDef, GridApi } from "ag-grid-community";
import { PaymentService } from '../../../../payments/services/payment.service';
import { Observable, of } from 'rxjs';
import { map } from "rxjs/operators";
import { ApplicationPayment, PaymentSearchCriteria } from '../../../../payments/models/paymentItem.model';
//import { DataTableComponent } from '../../../../common/components/data-table/data-table.component';
import { Router } from '@angular/router';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { GridFormatterService } from "../../../../common/services/grid-formatter.service";
import { ButtonRendererComponent } from "../../../../common/components/ag-grid/button-renderer.component";
import { AuthService } from "../../../../services/auth.service";

@Component({
    selector: 'external-payments-widget',
    templateUrl: './external-payments-widget.component.html',
    styleUrls: ['./external-payments-widget.component.scss'],
    standalone: false
})
export class ExternalPaymentsWidgetComponent implements OnInit, AfterViewInit {
    @Input() widgetTitle: string;


    columns: ColDef[] = [
        {
            headerClass: "wrapped",
            headerName: "Date Paid",
            headerTooltip: "Date Paid",
            field: "paymentDate",
            filter: "agDateColumnFilter",
            tooltipField: "paymentDate",
            valueFormatter: this.formatter.formatDate("paymentDate"),
            tooltipValueGetter: this.formatter.formatDate("paymentDate"),
            filterParams: this.formatter.defaultDateFilterParams,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Amount Paid",
            headerTooltip: "Amount Paid",
            field: "amountPaid",
            tooltipField: "amountPaid",
            valueGetter: this.formatter.formatCurrency("amountPaid"),
            tooltipValueGetter: this.formatter.formatCurrency("amountPaid"),
            filter: "agDateColumnFilter",
            filterParams: this.formatter.defaultDateFilterParams,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Application Type",
            headerTooltip: "Application Type",
            field: "applicationType",
            tooltipField: "applicationType",
            filter: "agTextColumnFilter"
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Application #",
            headerTooltip: "Application #",
            field: "applicationNumber",
            tooltipField: "applicationNumber",
            filter: "agTextColumnFilter",
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Details",
            cellRenderer: ButtonRendererComponent,
            cellRendererParams: {
                buttonText: "Details",
                action: (obj) => this.showDetails(obj)
            },
            minWidth: 100,
            maxWidth: 100
        } as ColDef
    ];
	gridOptions: GridOptions;
	gridApi?: GridApi;
    data$: Observable<ApplicationPayment[]>;


    constructor(
        private _paymentService: PaymentService,
        public _router: Router,
        private formatter: GridFormatterService,
        private auth: AuthService
    ) {
    }

    ngOnInit() {
        let spec: PaymentSearchCriteria = new PaymentSearchCriteria(this.auth.User.organizationId, "", [], []);
        spec.hasPayments = true;
        this.data$ = this._paymentService.search(spec).pipe(
            map((items: ApplicationPayment[]) => {
                return items.sort((a, b) => {
                    if (a.paymentDate > b.paymentDate) return -1;
                    if (a.paymentDate < b.paymentDate) return 1;
                    if (a.amountPaid > b.amountPaid) return -1;
                    if (a.amountPaid < b.amountPaid) return 1;
                    return 0;
                });
            })
        );
        
       
		this.gridOptions = this.formatter.BuildDefaultGridOptionsWithColumns(this.columns, false, true, true, false);
		this.gridOptions.onGridReady = (params) => { this.gridApi = params.api; };
    }

    ngAfterViewInit() {
        if (this.gridApi) this.gridApi.sizeColumnsToFit();
    }

    ngOnDestroy() {

    }

    showDetails(obj: any): void {
        this._router.navigate(["/payment/transaction", obj.id]);
    }
}
